import { Action } from "@ngrx/store";
import { ITimer } from "src/app/models/timer";

export enum ETimerActions {
  TimerOn = "[Timer] On",
}

export class TimerOn implements Action {
  public readonly type = ETimerActions.TimerOn;
  constructor(public payload: ITimer) {}
}

export type TimerActions = TimerOn;
